import React, { useContext, useEffect, useState } from "react";
import NewButton from "./NewButton";
import { ReactComponent as Close } from "../assets/icons/x.svg";
import { ReactComponent as MEMBERADMIN } from "../assets/icons/MemberAdmin.svg";
import { ReactComponent as MEMBER } from "../assets/icons/Member.svg";

import { FormTextInput } from "../Components/FormTextInput";
import { Info } from "react-feather";
import TeamDropdown from "../Screens/Account/OrdersComponents/TeamDropdown";
import { NotificationContext } from "../Context/NotificationContext";
import { firestore, getFullHttpUrl } from "../firebase.config";
import axios from "axios";
import { useEnterKey } from '../Hooks/useEnterKey';

const memberOptions = [{name: "New Member", value: "new-member"}, {name: "Exisiting Member", value: "exisiting-member"}];
const teamOptions = [{name: "New Team", value: "new-member"}, {name: "Exisiting Team", value: "exisiting-team"}];
const memberRoleOptions = ["member", "admin"];
const expeditedOptions = [{name: "Paid", value: "paid"}, {name: "Free", value: "free"}, {name: "Free+", value: "free-plus"}];

const AddTeamMemberPopUp = ({ onClose, existingTeams = [], currentTeam, singleTeam = false }) => {
  const { showNotification } = useContext(NotificationContext);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [invalidEmail, setInvalidEmail] = useState(false);
  const [email, setEmail] = useState('');
  const [teamName, setTeamName] = useState("");
  const [discount, setDiscount] = useState("");
  const [selectedExpedited, setSelectedExpedited] = useState(expeditedOptions[0].value);
  const [selectedMemberType, setSelectedMemberType] = useState(memberOptions[0].value);
  const [newPass, setNewPass] = useState("");
  const [selectedMemberRole, setSelectedMemberRole] = useState(memberRoleOptions[0]);
  const [selectedTeamType, setSelectedTeamType] = useState(teamOptions[0].value);
  const [selectedTeam, setSelectedTeam] = useState(currentTeam ? currentTeam.id : "");
  const [showStatusHoverBox, setShowStatusHoverBox] = useState(false);
  const [hoveredRole, setHoveredRole] = useState("");
  const [createBtn, setCreateBtn] = useState("Add Member to Team");
  const [existingMembers, setExistingMembers] = useState([]);

 useEffect(() => {
    firestore.collection("users").get().then(async (snapshot) => {
      if(snapshot.empty){
        return;
      }
        try {
          const userData = snapshot.docs.map((userDoc) => {
              return { id: userDoc.id, ...userDoc.data() };
            })
    
          setExistingMembers(userData.filter(u => u.temaId ? false : true));
        } catch (error) {
          console.error("Error fetching teams: ", error);
          showNotification("Error", "Failed to fetch team user data", "error");
        }
      });
    
  }, [currentTeam])

  const handleEmailChange = (value) => {
    setEmail(value);
    setInvalidEmail(false);
  }
  const handleMouseOver = (role) => {
    setHoveredRole(role);
    setShowStatusHoverBox(true);
  };

  const handleMouseOut = () => {
    setShowStatusHoverBox(false);
    setHoveredRole("");
  };

  const roleStatus = {
    member: "Can place/manage orders, invite users, and make payments.",
    admin: "Everything a Member can do, plus remove users, update payment methods, and change the payment approach.",
  };
  const roleIcons = {
    member: <MEMBER className="memberRoleIcon" />,
    admin: <MEMBERADMIN className="memberRoleIcon" />,
  };
  const [selectedUser, setSelectedUser] = useState('');

  const createTeam = async () => {
    setCreateBtn("Adding...");
    // const existingTeam = await firestore.collection("teams").where("name", "==", teamName.trim()).get();
  
    // if (!existingTeam.empty) {
    //   showNotification("Error", "A team with this name already exists. Please use a different name.", "error");
    //   return; 
    // }

    const teamRef = await firestore.collection("teams").add({
      name: teamName,
      discount: discount === "" || !discount ? 0 : parseInt(discount, 10),
      expeditedServices: selectedExpedited,
      lastInvoiceTimestamp: new Date().getTime(),
      orderPlacedNotifyToAll: false,
      orderCompletedNotifyToAll: false,
      quotePlacedNotifyToAll: false,
      quoteReadyNotifyToAll: false,
      status:'Active',
      timestamp: new Date().getTime(),
      shipping: [],
      billingTerm : "case-by-case",
      billingPeriod: null,
    });

    handleUser(teamRef.id);
  }

  const handleUser = async(teamId) => {
    setCreateBtn("Adding...");
    const data = selectedMemberType === memberOptions[0].value ? {
      teamId: teamId,
      teamRole: selectedMemberRole,
      name: firstName + " " + lastName,
      firstName: firstName,
      lastName: lastName,
      email: email.toLowerCase(),
      password: newPass,
    } : {
      teamId: teamId,
      teamRole: selectedMemberRole,
      userId: selectedUser.id,
      email: selectedUser.email,
    }

      await axios({
        method: "post",
        url: getFullHttpUrl("team-addMember"),
        data: {
          allDetails: data,
            existingUser: selectedMemberType === memberOptions[1].value && selectedUser ? true : false,
          },
      }).then(async (res) => {
          if(res.data.status === "member-updated"){
            onClose();
            return showNotification(
              "Success", 
              "Team Member added successfully.",
              "success"
            );
          }
        });
  }


    const handleAddMember = async () => {
      if(selectedMemberType === memberOptions[0].value && (!email || !firstName || !newPass)){
        showNotification("Error", "Please fill all required fields except last name.", "error");
        return;
      }
      if(selectedMemberType === memberOptions[1].value && !selectedUser){
        showNotification("Error", "Please select a User.", "error");
        return;
      }
      if(!singleTeam){
        if (selectedMemberType === memberOptions[1].value && !selectedTeam) {
          showNotification("Error", "Please select a team.", "error");
          return;
        }
        if (selectedTeamType === teamOptions[1].value && !selectedTeam) {
          showNotification("Error", "Please select a team.", "error");
          return;
        }

        if (selectedTeamType === teamOptions[0].value && selectedMemberType === memberOptions[0].value && !teamName) {
            showNotification("Error", "Team name is required.", "error");
            return;
        }
        if (parseInt(discount, 10) > 100) {
          showNotification("Error", "Discount is greater than 100.", "error");
          return;
        }
      }

      setCreateBtn("Adding...");

      try {
      if(!currentTeam && selectedTeamType === teamOptions[0].value && selectedMemberType === memberOptions[0].value ){
        await createTeam();
      }else{
        await handleUser(currentTeam ? currentTeam.id : selectedTeam);
      }
      } catch (error) {
        console.log(error);
        showNotification("Error", "Failed to create the team. Please try again.", "error");
      }finally{
        setCreateBtn("Add Member to Team");
        onClose();
      }
    };


    const onChangeDiscount = (discount) => {

      var reg = /^[0-9]+\.?[0-9]{0,3}$/;
  
      if (discount === "" || reg.test(discount)) {
        setDiscount(discount);
      }
    };

    useEnterKey(() => handleAddMember());

    const handleMemberTabChange = (option) => {
      if(option.value === "exisiting-member"){
        setSelectedUser("")
      }
      setSelectedMemberType(option.value)
    }
  

  return (
    <div className="newPopUpModalWrap">
      <div className="employeeUpdateModalContainer">
        <div className="employeeUpdateModalContainerScroll">
          <h2 className="newPopUpModalTitle">
            {"Add Team Member"}
          </h2> 
          <div className="employeeUpdateforsupport">
            <h4 className="employeePopUpModalTitle">Member</h4>
            <div className="expeditedTeamButton">
              {memberOptions.map((option, i) => (
                <div
                  key={option + i}
                  className={`memberButton ${selectedMemberType === option.value ? "selected" : ""
                    }`}
                  onClick={() => handleMemberTabChange(option)}
                >
                  <p>{option.name}</p>
                </div>
              ))}
            </div>

          </div>

          {selectedMemberType === memberOptions[1].value &&
            <TeamDropdown customClass={'selectTranslator'} icon={false}
              member={true}
              clients={existingMembers}
              onChange={(selectedUserData) => {
                setSelectedUser(selectedUserData);
              }} />
          }
          {
            selectedMemberType === memberOptions[0].value &&

            <FormTextInput type={"email"} incorrect={invalidEmail} clearInputIcon={true} placeholder="Email" value={email} onChange={handleEmailChange} />
          }{
            selectedMemberType === memberOptions[0].value && <div className="quoteDetailsInputsContainer">
              <FormTextInput type="text" placeholder="First Name" value={firstName} onChange={setFirstName} />
              <FormTextInput type="text" placeholder="Last Name" value={lastName} onChange={setLastName} />
            </div>
          }
          {
            selectedMemberType === memberOptions[0].value && <FormTextInput
              placeholder="Password"
              value={newPass}
              onChange={setNewPass}
              password
              showPasswordIcon
            />}


          <div className="employeeUpdateforsupport">
            <h4 className="employeePopUpModalTitle">Member Role</h4>
            <div className="quoteDetailsInputsContainer">
              {memberRoleOptions.map((option, i) => (
                <div
                  key={option + i}
                  className={`memberRoleButton ${selectedMemberRole === option ? "selected" : ""
                    }`}
                  onClick={() => setSelectedMemberRole(option)}
                >

                  <div className="memberOrderStatus">
                    {showStatusHoverBox && hoveredRole === option && (
                      <div className="teamStatusHover">
                        <p className="subTitle">{roleStatus[hoveredRole]}</p>
                      </div>
                    )}
                    {roleIcons[option]}
                    <p>{option}</p><Info className="statusIcon" onMouseOver={() => handleMouseOver(option)}
                      onMouseOut={handleMouseOut} /></div>
                </div>
              ))}
            </div>
          </div>
          <div className="employeeUpdateforsupport">
            <h4 className="employeePopUpModalTitle">Team</h4>
            {
              selectedMemberType === memberOptions[0].value && !currentTeam &&
              <div className="expeditedTeamButton">
                {teamOptions.map((option, i) => (
                  <div
                    key={option.value + i}
                    className={`memberButton ${selectedTeamType === option.value ? "selected" : ""
                      }`}
                    onClick={() => setSelectedTeamType(option.value)}
                  >
                    <p>{option.name}</p>
                  </div>
                ))}
              </div>
            }
             {currentTeam && <div className="teamDropdown">
                <FormTextInput value={currentTeam.name} disabled={true} />
              </div>}
          </div>
          {
            !currentTeam && (selectedMemberType === memberOptions[1].value || selectedTeamType !== teamOptions[0].value) && <p className="teamDropdown">
              <TeamDropdown customClass={'selectTranslator'} icon={false}
                clients={existingTeams}
                onChange={(selectedTeamData) => setSelectedTeam(selectedTeamData.id)} />
            </p>
          }
          {!currentTeam && selectedMemberType === memberOptions[0].value && selectedTeamType === teamOptions[0].value && <div className="quoteDetailsInputsContainer">
            <FormTextInput
              placeholder="Team Name"
              value={teamName}
              onChange={setTeamName}

            />
            <FormTextInput
              placeholder="Discount(%)"
              value={discount}
              onChange={onChangeDiscount}

            />
          </div>}
          {!currentTeam && selectedMemberType === memberOptions[0].value && selectedTeamType === teamOptions[0].value &&
            <div className="employeeUpdateforsupport">
              <h4 className="employeePopUpModalTitle">Expedited Service</h4>
              <div className="quoteDetailsInputsContainer">
                {expeditedOptions.map((option, i) => (
                  <div
                    key={option.vlaue + i}
                    className={`expeditedButton ${selectedExpedited === option.value ? "selected" : ""
                      }`}
                    onClick={() => setSelectedExpedited(option.value)}
                  >
                    <p>{option.name}</p>
                  </div>
                ))}
              </div>
            </div>
          }

          <div className="expeditedTeamButton">
            <NewButton text="Cancel" onClick={onClose} disabled={createBtn === "Adding..."} back={true} icon={false} whiteBtn={true}/>
            <NewButton text={createBtn} disabled={createBtn === "Adding..."} onClick={() => handleAddMember()} />
          </div>

          <Close className="newPopUpModalCloseIcon" onClick={onClose} />
        </div>
      </div>
    </div>
  );
};

export default AddTeamMemberPopUp;
